import React, { useState } from 'react';
import { connect } from 'react-redux';

import { workflowDeleteCondition } from '~/actions/workflow';
import { Button } from '~/eds/src/components/Button/Button';
import { injectIntl, useIntl } from 'react-intl';
import {
  getConditionErrors,
  getSidebarConditionItems,
} from '~/reducers/workflow';
import Box from '~/ui/components/Box/Box';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import { useModal } from '~/ui/hooks/modal';

import ConditionModal from './ConditionModal';
import ConfirmDelete from './ConfirmDelete';
import Item from './Item';

function Conditions({
  // connected
  conditions,
  disabled,
  errors,
  workflowDeleteCondition,
}) {
  const intl = useIntl();
  const [activeCondition, setActiveCondition] = useState(null);
  const [showConditionBuilderModal, setShowConditionBuilderModal] =
    useState(false);

  function removeActiveCondition() {
    setActiveCondition(null);
  }

  const [deleteModal, showDeleteModal] = useModal({
    actionButton: {
      text: intl.formatMessage({
        id: 'Conditions.deleteButton',
        defaultMessage: 'Delete',
        description: 'Delete button text',
      }),
      variant: 'red',
      errorHandler: () => {},
      promise: async () => {
        workflowDeleteCondition(activeCondition?.id);
      },
    },
    content: <ConfirmDelete condition={activeCondition} />,
    disableAutoHide: true,
    title: intl.formatMessage({
      id: 'Conditions.deleteModalTitle',
      defaultMessage: 'Delete Condition',
      description: 'Title for delete condition modal',
    }),
    onHide: removeActiveCondition,
  });

  return (
    <>
      <FlexLayout flexDirection="column" sx={{ minHeight: 0 }}>
        {disabled ? null : (
          <Box px={10} py={3} sx={{ borderBottom: 'border' }}>
            <Button
              id="workflow-sidebar--add-condition-button"
              isFullWidth
              text={intl.formatMessage({
                id: 'Conditions.addConditionButton',
                defaultMessage: 'Add Condition',
                description: 'Button text for adding a new condition',
              })}
              onClick={() => {
                setActiveCondition();
                setShowConditionBuilderModal(true);
              }}
            />
          </Box>
        )}
        <FlexLayout
          flexDirection="column"
          py={5}
          sx={{ borderBottom: 'border', overflow: 'auto' }}
        >
          {conditions.length === 0 && <Item />}
          {conditions.map((condition) => (
            <Item
              disabled={disabled}
              key={condition.id}
              hasError={errors.invalidConditionIds.has(condition.id)}
              item={condition}
              onEdit={() => {
                setActiveCondition(condition);
                setShowConditionBuilderModal(true);
              }}
              onDelete={() => {
                setActiveCondition(condition);
                if (condition.links.length > 0) {
                  showDeleteModal();
                } else {
                  workflowDeleteCondition(condition.id);
                }
              }}
            />
          ))}
        </FlexLayout>
      </FlexLayout>
      <ConditionModal
        condition={activeCondition}
        onHide={() => setShowConditionBuilderModal(false)}
        visible={showConditionBuilderModal}
      />
      {deleteModal}
    </>
  );
}

const mapStateToProps = ({ builder, workflow }, { intl }) => ({
  conditions: getSidebarConditionItems(workflow),
  disabled: !builder.shouldEnableAllComponents,
  errors: getConditionErrors(workflow, intl),
});

export default injectIntl(
  connect(mapStateToProps, { workflowDeleteCondition })(Conditions),
);
